define(['jquery'], ($) => {
    // return $.noConflict();
    return $; // TODO fix b-tabsheet
});
